import $ from "jquery";
import MobileDetect from "mobile-detect";

// append the head element
const em_base = 16;

const BREAKPOINT_SIZES = {
   "small": 0,
   "medium": 768,
   "large": 1200,
}

class MediaQueries extends (MobileDetect) {
    constructor(userAgent) {
        super(userAgent);
        this.flagPage();
    }

    flagPage = () => {
        if (this.is_touch_device) {
            $('body').addClass('touch-device');
        }
    };

   get smallBreakpoint(){
      return BREAKPOINT_SIZES.small
   }
   get mediumBreakpoint(){
      return BREAKPOINT_SIZES.medium
   }
   get largeBreakpoint(){
      return BREAKPOINT_SIZES.large
   }

   get is_ie() {
     return window.navigator.userAgent.indexOf("Trident") >= 0;
   }
   get is_touch_device() {
     return ('ontouchstart' in window || navigator.maxTouchPoints)?true:false;
   }
   get cq_edit_mode() {
     return ((typeof CQ === 'object') && CQ.WCM.isEditMode());
   }

   get is_macos() {
     return window.navigator.userAgent.indexOf("Mac OS") >= 0;
   }
}
export default new MediaQueries(window.navigator.userAgent)